export enum Country {
    ARGENTINE = 'Argentina'
}